/**
 * Application-wide constants
 */

/**
 * Default gross salary used throughout the application
 * when initializing person data or as a fallback value
 */
export const DEFAULT_GROSS_SALARY = 105000;
